import { render, staticRenderFns } from "./FoundationTitleEdit.vue?vue&type=template&id=004fb425"
import script from "./FoundationTitleEdit.vue?vue&type=script&lang=js"
export * from "./FoundationTitleEdit.vue?vue&type=script&lang=js"
import style0 from "./FoundationTitleEdit.vue?vue&type=style&index=0&id=004fb425&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports